import { useContext } from "react";
import { LinkPathTransformerContext } from "../context/link-path-transformer-context";
import { identity } from "lodash";
export var useLinkPathTransformer = function () {
  return useContext(LinkPathTransformerContext) || identity;
};